
<app-page-loader></app-page-loader>

@if (showHeroImg) {
    <div id="hlxHeroImage" class="d-print-none"></div>
}

@if (isDemo) {
    <app-demo-settings-selector></app-demo-settings-selector>
}


<router-outlet></router-outlet>

<hlx-consent-banner></hlx-consent-banner>
